import { FormattedMessage } from "react-intl";
import SamblaLogo from "../../assets/sambla.svg";
import { Flex, Modal, Title, Button, Anchor, Affix } from "@mantine/core";

export default function ExitOnboarding({
  opened,
  close,
}: {
  opened: boolean;
  close: () => void;
}) {
  return (
    <Modal.Root
      opened={opened}
      onClose={close}
      fullScreen
      transitionProps={{ transition: "fade", duration: 200 }}
      radius={0}
    >
      <Modal.Content bg="var(--wallet-color-sambla-red-shade-200)">
        <Modal.Header bg="var(--wallet-color-sambla-red-shade-900)" h={76}>
          <SamblaLogo />
          <Modal.CloseButton style={{ color: "white" }}></Modal.CloseButton>
        </Modal.Header>

        <Modal.Body
          display="flex"
          h="calc(100vh - var(--app-shell-header-height, 0px) - var(--app-shell-footer-height, 0px))"
          style={{
            justifyContent: "center",
            m: 0,
            alignItems: "center",
          }}
        >
          <Title order={2}>
            <FormattedMessage
              id="exitOnboarding.title"
              defaultMessage="Are you sure you want to leave your application?"
            />
          </Title>
        </Modal.Body>
        <Affix position={{ bottom: 0 }} bg={"white"} w={"100vw"} p={"lg"}>
          <Flex
            bg="white"
            h={74}
            bottom={0}
            pos={"fixed"}
            w={"100%"}
            justify="center"
            align="center"
            style={{ zIndex: 99999 }}
          >
            <Flex gap="2rem" style={{ zIndex: 99999 }}>
              <Button variant="outline" onClick={close}>
                Nej
              </Button>
              <Anchor href={`${import.meta.env.VITE_LANDING_URL}`}>
                <Button>Ja</Button>
              </Anchor>
            </Flex>
          </Flex>
        </Affix>
      </Modal.Content>
    </Modal.Root>
  );
}
